'use strict';
// eslint-disable-next-line max-params, max-lines-per-function
angular.module('webAgro1App').controller('DemandaUsoInsumosCtrl', function(
  $rootScope,
  $scope,
  $uibModalInstance,
  $timeout,
  MessagesService,
  DemandaUsoInsumosService,
  PropriedadesService,
  operacao,
  cronograma,
  aguardandoAprovacao,
  aplicacoes
) {
  $scope.periodo = {};
  $scope.application = [];
  $scope.params = {
    period: {},
    propriedades: [],
    tipo_relatorio: ''
  };
  PropriedadesService.all().then(function(propriedades) {
    $scope.allPropriedades = propriedades.data;

    $scope.params = {
      period: {
        startDate: moment().toDate(),
        endDate: moment().add(7, 'days')
          .toDate()
      },
      propriedades: [_.find($scope.allPropriedades, { id: $rootScope.currentPropriedade.id })],
      atual: new Date()
    };
  }, function(error) {
    console.error('Erro listando as propriedades', error);
  });

  // eslint-disable-next-line max-lines-per-function
  $scope.get = function() {
    $scope.loading = true;

    $scope.params.startDate = moment($scope.params.period.startDate).toDate();
    $scope.params.endDate = moment($scope.params.period.endDate).toDate();

    if ($scope.params.tipo_relatorio === 'aplicacoes') {
      $scope.application = aplicacoes.map((aplicacao) => {
        const propriedade = $rootScope.propriedades.find((prop) => prop.id === aplicacao.propriedade.id);

        if (aplicacao.tipo_operacao_enum === 'operacao_tratamento_semente') {
          const auditoriaAplicacao = aplicacao.auditoria_aplicacao.objeto.atributo_attributes;
          auditoriaAplicacao.dt_ini = moment(auditoriaAplicacao.data_hora_inicio).toDate();
          auditoriaAplicacao.dt_fim = moment(auditoriaAplicacao.data_hora_fim).toDate();

          return {
            ...aplicacao,
            auditoria_aplicacao: auditoriaAplicacao
          };
        }

        aplicacao.auditoria_aplicacao.dt_ini = moment(aplicacao.auditoria_aplicacao.dt_ini).toDate();
        aplicacao.auditoria_aplicacao.dt_fim = moment(aplicacao.auditoria_aplicacao.dt_fim).toDate();

        const aplicacaoGleba = propriedade.glebas.find((gleba) => gleba.id === aplicacao.gleba.id);
        return {
          ...aplicacao,
          gleba: { ...aplicacao.gleba, area: aplicacaoGleba.area_total }
        };
      });

      $scope.application = _.orderBy($scope.application, 'created_at');
      $timeout(function() {
        $('#print_insumos_aplicacao_pendente').click();
      });
      $scope.loading = false;
    } else {
      DemandaUsoInsumosService.get($scope.getParams()).then(function(result) {
        $scope.data = result.data;

        $timeout(function() {
          $('#btn-print').click();
        });
      }, function() {
        MessagesService.alert('Falha ao carregar dados, tente novamente mais tarde.');
      })
        .finally(function() {
          $scope.loading = false;
        });
    }
  };

  $scope.opts = {
    locale: {
      applyClass: 'btn-green',
      format: 'DD/MM/YYYY',
      applyLabel: 'Ok',
      fromLabel: 'Até',
      toLabel: 'De',
      cancelLabel: 'Cancelar',
      customRangeLabel: 'Customizado',
      daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      firstDay: 1,
      monthNames: [
        'Janeiro',
        'Feveiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ]
    },
    ranges: {
      'Últimos 7 dias': [moment().subtract(7, 'days'), moment()],
      'Últimos 30 dias': [moment().subtract(30, 'days'), moment()]
    }
  };

  $scope.getParams = function() {
    const propriedades = $scope.params.propriedades.map(function(propriedade) {
      return propriedade.id;
    }).join(',');

    const params = {
      data_inicial: moment($scope.params.period.startDate).format('Y-MM-DD'),
      data_final: moment($scope.params.period.endDate).format('Y-MM-DD'),
      operacao: operacao.id,
      propriedades: propriedades,
      demandas_cronograma: cronograma
    };

    if (aguardandoAprovacao) {
      params.aguardando_aprovacao = true;
    }

    return params;
  };

  $scope.close = function() {
    $uibModalInstance.dismiss('cancel');
  };
});
